import Banner from '../../components/Banner';
import Layout from '../../components/Layout';
import Detail from '../../components/Outlet/Detail';
import { useDispatch, useSelector } from 'react-redux';
import { HeaderSlot, UFOODX_BASE_URL, uniqueID } from '../../../utils/constants';
import { encodeValue, isEmptyData, sendAnalyticsPageView } from '../../../utils/helper';
import { useEffect, useMemo, useRef, useState } from 'react';
import Loader from '../../../components/Loader';
import SearchMenu from '../../components/Outlet/Search';
import { clearDetail, handleGetProductsOutlet, handleGetProductsOutletV2, setProducts } from '../../../store/reducers/product';
import { DetailProduct } from '../../components/Product';
import { handleGetCartDetail } from '../../../store/reducers/cart';
import useScroll from '../../../hook/useScroll';
import { setLayout } from '../../../store/reducers/layout';
import { useParams } from 'react-router-dom';
import ListProduct from '../../components/Outlet/ListProduct';
import Checkout from '../../components/Checkout';
import { handleGetStoreDetail } from '../../../store/reducers/outlet';
import Header from '../../components/Header';
import useNavigation from '../../../hook/useNavigation';
import useToast from '../../../components/Toast';
import useRedirectQR from '../../hook/useRedirectQR';
import InputTableNumber from '../../components/Outlet/InputTableNumber';
import QRScanner from '../../components/QRScanner';
import { tableNumberAuto } from '../../../store/reducers/order';

const Outlet = () => {
	const { type, slug } = useParams();
	useRedirectQR();
	const navigate = useNavigation();
	const dispatch = useDispatch();
	const { showToast } = useToast();
	const { isScrolled } = useScroll();

	const user = useSelector((store) => store?.user);
	const { details: outlet, loading: isLoadingOutlet, isLoadingOtherLocation } = useSelector((store) => store?.outlet);
	const fetchAttemptedRef = useRef(false);
	const { loadingDetail: isLoadingDetailProduct } = useSelector((store) => store?.product);
	const { orderTypeOptions, isLoadingOrderTypeOptions, selectedOrderType, tableNumber } = useSelector((store) => store?.order);
	const { minScrollHeight } = useSelector((store) => store.layout);
	const defaultMinScrollHeight = 375;

	const [isShowTableNumber, setIsShowTableNumber] = useState(false);
	const [isShowScanner, setShowScanner] = useState(false);
	const company = useSelector((store) => store?.company);

	const handleGetProducts = async () => {
		dispatch(
			handleGetProductsOutletV2({
				uniqueID,
				storeID: encodeValue(outlet?.storeID),
			}),
		);
	};

	const handleGetCart = async () => {
		dispatch(
			handleGetCartDetail({
				customerID: encodeValue(user?.customerID),
				companyID: encodeValue(user?.companyID),
				storeID: encodeValue(outlet?.storeID),
				availabilityID: selectedOrderType?.av_id
			}),
		);
	};

	const handleGetOutlet = async () => {
		dispatch(
			handleGetStoreDetail({
				storeID: slug,
				latitude: user?.latitude,
				longitude: user?.longitude,
			}),
		);
	};

	useEffect(() => {
		if (!outlet?.storeID) return;
		handleGetProducts();
	}, [outlet?.storeID, type]);

	useEffect(() => {
		if (!outlet?.storeID || !user?.customerID || !user?.companyID) return;
		handleGetCart();
	}, [user?.customerID, user?.companyID, outlet?.storeID, selectedOrderType]);

	useEffect(() => {
		if (!slug) return;
		handleGetOutlet();
	}, [slug, user?.latitude, user?.longitude]);

	useEffect(() => {
		if (minScrollHeight !== defaultMinScrollHeight) {
			dispatch(
				setLayout({
					minScrollHeight: defaultMinScrollHeight,
				}),
			);
		}
	}, [minScrollHeight, isScrolled]);

	useEffect(() => {
		dispatch(
			setProducts({
				keyword: null,
			}),
		);
		dispatch(clearDetail());
	}, []);

	useEffect(() => {
		if (isLoadingOrderTypeOptions || isEmptyData(orderTypeOptions)) return;
		const find = orderTypeOptions?.find((o) => o?.av_name?.toLowerCase()?.replace(/\s+/g, "") === type);
		if (isEmptyData(find)) {
			showToast('error', 'Tipe Order Tidak Tersedia', 2000).then(() => {
				return navigate.push(UFOODX_BASE_URL);
			});
		}

		if (type === 'dinein' && isEmptyData(tableNumber?.table_number)) {
			if (isEmptyData(outlet?.dinein_qr_code)) {
				dispatch(
					tableNumberAuto({
						companyId: Number(company?.companyID),
						outletId: Number(outlet?.storeID),
						brandId: Number(outlet?.brand_id),
					})
				);
			} else {
				if (outlet?.dinein_qr_code) {
					setIsShowTableNumber(true);
					return;
				} else {
					//access open camera
					setShowScanner(true);
				}
			}
		}
	}, [isLoadingOrderTypeOptions, orderTypeOptions, tableNumber?.table_number]);

	useEffect(() => {
		if (isLoadingOutlet) {
			fetchAttemptedRef.current = true;
		} else if (fetchAttemptedRef.current && isEmptyData(outlet)) {
			navigate.push('/ufood-x/not-found');
		}
	}, [isLoadingOutlet, outlet]);

  useEffect(() => {
    if (isEmptyData(outlet?.storeName) || typeof window.gtag !== 'function') return;
    sendAnalyticsPageView(outlet?.storeName);
  }, [outlet?.storeName, window.gtag, selectedOrderType?.av_name]);

	const outletProps = {
		name: outlet?.storeName,
		image: outlet?.storeImage,
		isOpen: outlet?.storeOpen,
		tableNumber: tableNumber?.table_number
	};

	const bannerProps = useMemo(() => {
		return {
			data: [
				{
					banner_image: outlet?.bannerImage,
				},
			],
			isLoading: isLoadingOutlet,
			className: 'w-screen !-m-4 relative max-w-3xl',
		};
	}, [outlet?.bannerImage]);

	const headerProps = useMemo(() => {
		return {
			slots: {
				left: {
					content: HeaderSlot.BACK
				},
				center: {
					content: HeaderSlot.NAME,
					className: 'ml-2'
				},
				right: {
					content: !isScrolled ? HeaderSlot.TYPE : HeaderSlot.SEARCH,
				}
			},
		};
	}, [isScrolled]);

	const pageLoading = isLoadingDetailProduct || isLoadingOtherLocation;

	const handleCloseTableNumber = () => {
		setIsShowTableNumber(false);
	};

	return (
		<Layout>
			{pageLoading && <Loader overlay className={'-mx-4'} />}
			<Header {...headerProps} />
			<Banner {...bannerProps} />
			<Detail {...outletProps} />
			<SearchMenu />
			<ListProduct />
			<DetailProduct />
			<Checkout />

			<InputTableNumber open={isShowTableNumber} onClose={handleCloseTableNumber} />
			{isShowScanner && <QRScanner onClose={() => setShowScanner(false)} />}
		</Layout>
	);
};

export default Outlet;
